import type { ShellHydration } from '../../../api.js';
import type { SurveyIdentityConfig } from '../types.js';

export function resolveKnownEmail(hydration: ShellHydration): string | undefined {
  const email = hydration.user?.email?.trim();
  if (email && isValidEmail(email)) return email;
  const uniqueId = hydration.user?.uniqueId?.trim();
  if (uniqueId && isValidEmail(uniqueId)) return uniqueId;
  return undefined;
}

export function shouldPromptLateIdentity(
  config: SurveyIdentityConfig | undefined,
  collectedEmail: string,
): boolean {
  if (collectedEmail.trim() !== '') return false;
  return config?.mode === 'emailRequired' || config?.mode === 'emailOptional';
}

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}
